// extracted by mini-css-extract-plugin
export default {"container":"ViewSupply_container_d4181","innerShadow":"ViewSupply_innerShadow_ed6e6","back":"ViewSupply_back_eddd2"};